import Vue from 'vue'

Vue.mixin({
  methods: {
    onCallToastr(type = 'success', message, title, timeOut = 2000) {
      window.toastr.clear()
      window.toastr.options.closeButton = true;

      if (type === 'warning') window.toastr.warning(message, title, {timeOut: timeOut})
      if (type === 'error') window.toastr.error(message, title, {timeOut: timeOut})
      if (type === 'success') window.toastr.success(message, title, {timeOut: timeOut})
    },
  }
});
